module.exports = __webpack_public_path__ + "img/mobile_pic_chi.399512d5.png";